/* ═══════════════════════════════════════════════════════════════════════
   Lake Life Designs - Variant Picker (variant-picker.js)

   Enforces explicit option selection before Add to Cart:
   - Nothing is pre-selected (except options that only have one value)
   - Clicking an option actually updates the hidden variant id
   - Combinations that do not exist are disabled
   - Submitting with a missing option shows a prompt anchored to that
     option group, scrolls to it, and highlights it
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var form = document.querySelector('[data-add-to-cart-form]');
  if (!form) return;

  var picker = form.querySelector('[data-variant-picker]');
  var idInput = form.querySelector('[data-variant-id]');
  var submitBtn = form.querySelector('[data-add-to-cart]');
  if (!idInput || !submitBtn) return;

  /* ── Parse variant data ─────────────────────────────────────────────── */
  var variants = [];
  var priceMap = {};
  try {
    var vEl = document.querySelector('[data-variant-json]');
    if (vEl) variants = JSON.parse(vEl.textContent) || [];
  } catch (e) { variants = []; }
  try {
    var pEl = document.querySelector('[data-variant-prices]');
    if (pEl) priceMap = JSON.parse(pEl.textContent) || {};
  } catch (e) { priceMap = {}; }

  /* Single-variant product: nothing to choose, wire the id and stop */
  if (!picker) {
    if (variants.length === 1) idInput.value = variants[0].id;
    return;
  }

  var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-option-group]'));
  if (!groups.length) return;

  /* selected[position] = "Navy" */
  var selected = {};

  /* ── Helpers ────────────────────────────────────────────────────────── */

  function variantOption(variant, position) {
    if (variant.options && variant.options.length >= position) {
      return variant.options[position - 1];
    }
    return variant['option' + position];
  }

  /* Find the variant matching every current selection */
  function matchedVariant() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var pos in selected) {
        if (!Object.prototype.hasOwnProperty.call(selected, pos)) continue;
        if (variantOption(v, parseInt(pos, 10)) !== selected[pos]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Does any variant exist with this value, given the OTHER selections? */
  function combinationState(position, value) {
    var exists = false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (variantOption(v, position) !== value) continue;

      var ok = true;
      for (var pos in selected) {
        if (!Object.prototype.hasOwnProperty.call(selected, pos)) continue;
        if (parseInt(pos, 10) === position) continue;
        if (variantOption(v, parseInt(pos, 10)) !== selected[pos]) { ok = false; break; }
      }
      if (!ok) continue;

      exists = true;
      if (v.available) return 'available';
    }
    return exists ? 'soldout' : 'missing';
  }

  function everyOptionChosen() {
    return groups.every(function (g) {
      return selected[parseInt(g.getAttribute('data-option-position'), 10)];
    });
  }

  function firstMissingGroup() {
    for (var i = 0; i < groups.length; i++) {
      var pos = parseInt(groups[i].getAttribute('data-option-position'), 10);
      if (!selected[pos]) return groups[i];
    }
    return null;
  }

  /* ── Prompts ────────────────────────────────────────────────────────── */

  function clearPrompt(group) {
    group.classList.remove('is-missing');
    var hint = group.querySelector('[data-variant-hint]');
    if (hint) hint.hidden = true;
  }

  function clearAllPrompts() {
    groups.forEach(clearPrompt);
  }

  function showPrompt(group) {
    clearAllPrompts();
    group.classList.add('is-missing');
    var hint = group.querySelector('[data-variant-hint]');
    if (hint) hint.hidden = false;

    var rect = group.getBoundingClientRect();
    var offscreen = rect.top < 90 || rect.bottom > window.innerHeight;
    if (offscreen) {
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Re-trigger the attention animation */
    group.classList.remove('is-nudging');
    void group.offsetWidth;
    group.classList.add('is-nudging');
    setTimeout(function () { group.classList.remove('is-nudging'); }, 700);
  }

  /* ── UI sync ────────────────────────────────────────────────────────── */

  function updateOptionAvailability() {
    groups.forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      group.querySelectorAll('.variant-btn').forEach(function (btn) {
        var state = combinationState(pos, btn.getAttribute('data-value'));
        btn.classList.toggle('is-soldout', state === 'soldout');
        btn.disabled = (state === 'missing');
      });
    });
  }

  function updateChosenLabels() {
    groups.forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      var chosen = group.querySelector('[data-chosen-value]');
      var needed = group.querySelector('[data-needed-flag]');
      if (selected[pos]) {
        if (chosen) chosen.textContent = selected[pos];
        if (needed) needed.hidden = true;
        group.classList.add('is-chosen');
      } else {
        if (chosen) chosen.textContent = '';
        if (needed) needed.hidden = false;
        group.classList.remove('is-chosen');
      }
    });
  }

  function updatePrice(variant) {
    var info = variant ? priceMap[variant.id] : null;
    if (!info) return;
    var priceEl = document.querySelector('.product-info__price');
    var compareEl = document.querySelector('.product-info__price--compare');
    if (priceEl) priceEl.textContent = info.price;
    if (compareEl) {
      if (info.on_sale) {
        compareEl.textContent = info.compare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  function updateImage(variant) {
    if (!variant) return;
    var src = variant.featured_image && variant.featured_image.src;
    if (!src) return;
    var mainImg = document.querySelector('.product-gallery__main img');
    if (!mainImg) return;
    /* Ask the CDN for a sensible size */
    mainImg.src = src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_900x$1');
    mainImg.removeAttribute('srcset');
  }

  function updateSubmitButton(variant) {
    var complete = everyOptionChosen();

    if (!complete) {
      submitBtn.classList.add('is-incomplete');
      submitBtn.disabled = false; /* stays clickable so we can prompt */
      submitBtn.textContent = submitBtn.getAttribute('data-label-choose') || 'Select Options Above';
      return;
    }

    submitBtn.classList.remove('is-incomplete');

    if (!variant) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Unavailable';
    } else if (!variant.available) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sold Out';
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-label-default') || 'Add to Cart';
    }
  }

  function refresh() {
    updateOptionAvailability();
    updateChosenLabels();

    var variant = everyOptionChosen() ? matchedVariant() : null;
    idInput.value = (variant && variant.available) ? variant.id : '';

    updatePrice(variant);
    updateImage(variant);
    updateSubmitButton(variant);
  }

  /* ── Option clicks ──────────────────────────────────────────────────── */

  picker.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      var pos = parseInt(btn.getAttribute('data-option'), 10);
      var val = btn.getAttribute('data-value');
      var group = btn.closest('[data-option-group]');

      selected[pos] = val;

      group.querySelectorAll('.variant-btn').forEach(function (b) {
        var on = (b === btn);
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      clearPrompt(group);
      refresh();

      /* If something else is still missing, guide them straight there */
      var next = firstMissingGroup();
      if (next) showPrompt(next);
    });
  });

  /* ── Seed any auto-selected single-value options ────────────────────── */
  picker.querySelectorAll('.variant-btn.active').forEach(function (btn) {
    selected[parseInt(btn.getAttribute('data-option'), 10)] = btn.getAttribute('data-value');
  });

  /* ── Block submission until every option is chosen ──────────────────── */
  /* Capture on document so this runs before the form's own submit handler */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;

    var missing = firstMissingGroup();
    if (missing) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showPrompt(missing);
      submitBtn.classList.remove('is-shaking');
      void submitBtn.offsetWidth;
      submitBtn.classList.add('is-shaking');
      setTimeout(function () { submitBtn.classList.remove('is-shaking'); }, 500);
      return;
    }

    if (!idInput.value) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  /* Clicking a disabled button still gives feedback */
  submitBtn.addEventListener('click', function () {
    var missing = firstMissingGroup();
    if (missing) showPrompt(missing);
  });

  refresh();
  clearAllPrompts();

})();
